export function saveSorting(tableName: string, sortBy: string, sortDirection: boolean) {
  localStorage.setItem(
    btoa(tableName),
    JSON.stringify({
      sortBy,
      sortDirection,
    }),
  );
}

export function loadSorting(tableName: string): { sortBy: any; sortDirection: boolean } {
  const item = localStorage.getItem(btoa(tableName));
  if (!item) {
    return null;
  }
  return JSON.parse(item);
}
